export const ENTERPRISE_PAGE_MAP = {
  eddiev: {
    pages: ["/", "/home"],
  },
  thecapitalgrille: {
    pages: ["/", "/home"],
  },
  thecapitalburger: {
    pages: ["/", "/home"],
  },
  seasons52: {
    pages: ["/", "/home"],
  },
  yardhouse: {
    pages: ["/", "/home"],
  },
  chuys: {
    pages: ["/", "/home"],
  },
  ruthschris: {
    pages: ["/", "/home"],
  },
  cheddars: {
    pages: ["/", "/home"],
  },
  longhornsteakhouse: {
    pages: ["/", "/home"],
  },
  bahamabreeze: {
    pages: ["/", "/home"],
  },
  olivegarden: {
    pages: ["/", "/home", "/about-us", "/catering"],
  },
};
